import { ThemeOptions } from "@material-ui/core/styles/createMuiTheme";
import parcelLogo from "../../images/dpdLogoRedLight.png";
import driver from "../../images/driverRed.jpg";
import collectFromDepot from "../../images/CollectFromDepot.jpg";
import collectFromPickup from "../../images/CollectFromPickup.jpg";
import spinner from "../../images/dpdSpinnerRed.gif";
import driverBgBanner from "../../images/RedDriver.jpg";
import collectFromDepotMobile from "../../images/MobileBackgrounds/CollectFromDepot.png";
import driverBgBannerMobile from "../../images/MobileBackgrounds/RedDriver.png";
export const images = {
  spinner,
  driver,
  parcelLogo,
  collectFromDepot,
  collectFromPickup,
  driverBgBanner,
  collectFromDepotMobile,
  driverBgBannerMobile
};
export default {
  dpdSiteUrl: "https://www.dpd.co.uk",
  palette: {
    primary: {
      main: "#dc0032",
      contrastText: "#fff"
    }
  }
};